// @ts-nocheck
/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    link = "link",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.link]: LinkFieldValue;
    };
}

export interface IframeStyles {
    wrapper?: InjectableCss;
}

export const iframeStyles: IframeStyles = {
    wrapper: {
        css: css`
            padding-top: ${pxToRem(16)};
            width: 100%;
            iframe {
                width: 100%;
                height: 70vh;
                border: none;
            }
        `,
    },
};

export const IFrame: FC<OwnProps> = ({ fields }) => {
    const link = useGetLink(fields.link);
    const styles = iframeStyles;
    return (
        <StyledWrapper {...styles.wrapper}>
            <iframe src={link.url}></iframe>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: IFrame,
    definition: {
        group: "Basic",
        icon: "crop-simple",
        fieldDefinitions: [
            {
                name: fields.link,
                displayName: "IFrame Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Url",
                },
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
